import React, { useState } from "react";
import { useAuth } from "../../../../contexts/authContext";
import { addRecord } from "../../../../firebase/db/catalog/crud.tsx";
import { useNavigate } from "react-router-dom";

const FormModal = ({ isOpen, onClose }) => {
	const navigate = useNavigate();
	const { currentUser } = useAuth();
	const [formData, setFormData] = useState({
		audio_url: "",
		bpm: null,
		created: "",
		demo_exclusive_to: "",
		internal_song_name: "",
		is_demo_exclusive: false,
		is_released: false,
		key: "",
		length: "",
		modified: "",
		song_name: "",
		song_status: "",
		user_id: ""
	});

	if (!isOpen) return null;

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleClose = () => {
		setFormData();
		onClose();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		formData.created = new Date();
		formData.modified = new Date();
		formData.user_id = currentUser.uid;
		console.log("document: " + JSON.stringify(formData));
		const document = await addRecord(formData);

		handleClose();
		navigate(`/home/view/${document.id}`);
	};

	return (
		// <div id="extralarge-modal" tabIndex={-1} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
		<div
			className="fixed inset-0 flex
                        items-center justify-center
                        bg-black bg-opacity-50">
			<div id="medium-modal" className="fixed items-center justify-center z-50 p-4 inset-0 content-center">
				<div className="relative max-w-lg max-h-full mr-auto ml-auto">
					<div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
						<div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
							<h3 className="text-xl font-medium text-gray-900 dark:text-white">New Song Form</h3>
							<button
								onClick={onClose}
								type="button"
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
								data-modal-hide="extralarge-modal">
								<svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
									/>
								</svg>
								<span className="sr-only">Close modal</span>
							</button>
						</div>

						<div className="modal-body p-4 md:p-5 space-y-4">
							<form onChange={handleChange} className="">
								<div className="flex gap-8">
									<div className="flex-auto">
										<div className="grid md:grid-cols-1 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="internal_song_name"
													id="internal_song_name"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/>

												<label
													for="internal_song_name"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Song Name <span className="text-red-600">*</span>
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-1 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="song_name"
													id="song_name"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/>
												<label
													for="song_name"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Published Song Name
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-2 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="bpm"
													id="bpm"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/>
												<label
													for="bpm"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													BPM
												</label>
											</div>
											<div className="relative z-0 w-full mb-5 group">
												<input
													type="text"
													name="key"
													id="key"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/>
												{/* <PhoneInput
													name="mobile-phone"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder="Enter phone number"
													value={value}
													onChange={handleSetValue}
													defaultCountry="US"
												/> */}
												<label
													for="key"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Key
												</label>
											</div>
										</div>
										<div className="grid md:grid-cols-1 md:gap-6">
											<div className="relative z-0 w-full mb-5 group">
												<textarea
													id="description"
													name="description"
													rows="4"
													class="block py-2.5 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "></textarea>
												{/* <input
													type="text"
													name="country"
													id="country"
													className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
													placeholder=" "
													required
												/> */}
												<label
													for="description"
													className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
													Description
												</label>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div className="modal-footer justify-end flex items-center p-4 md:p-5 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b dark:border-gray-600">
							<div className="modal-footer>">
								<button
									onClick={handleClose}
									type="button"
									className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
									Cancel
								</button>
								<button
									onClick={handleSubmit}
									// data-modal-hide="extralarge-modal"
									type="button"
									className=" py-2.5 px-5 ms-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
									Save
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FormModal;
